import axios from 'axios'

const baseURL = process.env.VUE_APP_API_URL

const publicApi = axios.create({ baseURL })

export async function getInscricaoInfo() {
  const { data } = await publicApi.get('/inscricao/info')
  return data
}

export async function submitInscricao(payload) {
  const { data } = await publicApi.post('/inscricao', payload)
  return data
}
